/** Same key as `MockBridge` in `apps/tv/src/bridge` (docs/12, docs/13 §2). */
export const DEVICE_ID_KEY = 'akp.deviceId';

function uuid(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

let memory: string | null = null;

/** Private mode loses `localStorage`; the in-memory id still holds for this page load. */
export function webDeviceId(storage: Pick<Storage, 'getItem' | 'setItem'> = localStorage): string {
  try {
    const stored = storage.getItem(DEVICE_ID_KEY);
    if (stored) return stored;
    const fresh = memory ?? uuid();
    storage.setItem(DEVICE_ID_KEY, fresh);
    memory = fresh;
    return fresh;
  } catch {
    memory ??= uuid();
    return memory;
  }
}
